import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { MissionSection } from './components/MissionSection';
import { AboutSection } from './components/AboutSection';
import { ActivitiesSection } from './components/ActivitiesSection';
import { NewsSection } from './components/NewsSection';
import { ContactSection } from './components/ContactSection';
import { SupportSection } from './components/SupportSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-gray-900 font-sans" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <MissionSection data-id="element-4" />
        <AboutSection data-id="element-5" />
        <ActivitiesSection data-id="element-6" />
        <NewsSection data-id="element-7" />
        <SupportSection data-id="element-8" />
        <ContactSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}